export const splitTitle = (title) => {
    const titleSplitted = title.split('-', 1);
    titleSplitted[0] = titleSplitted[0].trim();
    return titleSplitted[0];
};
export const splitPath = (appState) => {
    const result = appState && appState.page && appState.page.split('/');
    return result && result.slice(1, result.length);
};
export const capitalizeFirstLetter = (string) => {
    return string && string.charAt(0).toUpperCase() + string.slice(1);
};
export const capitalizeOnlyFirstLetter = (string) => {
    return string && string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
export const toKebabCase = (string) => {
    let kebabCaseString = null;
    if (string) {
        kebabCaseString = string.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]+[0-9]*|[A-Z]|[0-9]+/g);
    }
    return kebabCaseString && kebabCaseString.map(x => x.toLowerCase()).join('-');
};
export const toKebabCaseWithAccents = (string) => {
    let kebabCaseString = null;
    if (string) {
        kebabCaseString = string.match(/[A-Z]{2,}(?=([A-Z]|[À-Ö])([a-z]|[Ø-ö]|[ø-ÿ])+[0-9]*|\b)|([A-Z]|[À-Ö])?([a-z]|[Ø-ö]|[ø-ÿ])+[0-9]*|([A-Z]|[À-Ö])+[0-9]*|([A-Z]|[À-Ö])|[0-9]+/g);
    }
    return kebabCaseString && kebabCaseString.map(x => x.toLowerCase()).join('-');
};
export const toKebabCaseWithAccentsAndCyrillic = (string) => {
    let kebabCaseString = null;
    if (string) {
        kebabCaseString = string.match(/[A-Z]{2,}(?=([A-Z]|[À-Ö])([a-z]|[Ø-ö]|[ø-ÿ]|[a-ö-w-я])+[0-9]*|\b)|([A-Z]|[À-Ö])?([a-z]|[Ø-ö]|[ø-ÿ]|[a-ö-w-я])+[0-9]*|([A-Z]|[À-Ö])+[0-9]*|([A-Z]|[À-Ö])|[0-9]+/g);
    }
    return kebabCaseString && kebabCaseString.map(x => x.toLowerCase()).join('-');
};
export const toKebabCaseWithAccentsCyrillicCJK = (stringInput) => {
    var _a, _b, _c;
    let kebabCaseString = null;
    const string = (_c = (_b = (_a = stringInput === null || stringInput === void 0 ? void 0 : stringInput.split) === null || _a === void 0 ? void 0 : _a.call(stringInput, '-')) === null || _b === void 0 ? void 0 : _b.join) === null || _c === void 0 ? void 0 : _c.call(_b, ' ');
    if (string) {
        kebabCaseString = string.match(/[A-Z]{2,}(?=([A-Z]|[À-Ö])([a-z]|[Ø-ö]|[ø-ÿ]|[a-ö-w-я]|[\u3006\u3007\u4e00-\u9fff\u3400-\u4dbf\U00020000-\U0002a6df\U0002a700-\U0002ebef\U00030000-\U0003134f])+[0-9]*|\b)|([A-Z]|[À-Ö])?([a-z]|[Ø-ö]|[ø-ÿ]|[a-ö-w-я]|[\u3006\u3007\u4e00-\u9fff\u3400-\u4dbf\U00020000-\U0002a6df\U0002a700-\U0002ebef\U00030000-\U0003134f])+[0-9]*|([A-Z]|[À-Ö])+[0-9]*|([A-Z]|[À-Ö])|[0-9]+/g);
    }
    return kebabCaseString && kebabCaseString.map(x => x.toLowerCase()).join('-');
};
export const trim = (string) => {
    return string && string.trim();
};
export const snakeToCamel = (str) => str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
export const multipleToSingleSpace = (str) => str.replace(/\s{2,}/g, ' ');
export const removeMarkdown = (text) => text
    .replace(/__(\S(.*?\S)?)__/gm, '$1')
    .replace(/_(\S(.*?\S)?)_/gm, '$1')
    .replace(/\*\*(\S(.*?\S)?)\*\*/gm, '$1');
export const removeMarkdownCustomText = (text) => text.replace(/(<([^>]+)>)/ig, '');
//# sourceMappingURL=string.js.map